module.exports = __webpack_public_path__ + "img/saludable.61762f52.webp";